import { render, staticRenderFns } from "./itemWrapper.vue?vue&type=template&id=ecda8b6e&scoped=true"
import script from "./itemWrapper.vue?vue&type=script&lang=js"
export * from "./itemWrapper.vue?vue&type=script&lang=js"
import style0 from "./itemWrapper.vue?vue&type=style&index=0&id=ecda8b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecda8b6e",
  null
  
)

export default component.exports